import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  createAccount() {
    alert('feature to be implemented')
  }

}



// WEBPACK FOOTER //
// ./src/app/page_components/login/login.component.ts